export default "__VITE_ASSET__JseWJBFu__"